import React, { ReactElement } from 'react';
import { StatusCodes } from 'http-status-codes';
import { NotFoundPage } from 'b2b-apps/shop/common/components/NotFoundPage';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { EnhancedComponentProps, EnhancedComponentType, WrappedComponentType } from './withNotFoundHandler.types';

export const withNotFoundHandler = <
  P extends EnhancedComponentProps,
  R extends RemoteRecord<any> = RemoteRecord<any>,
>(
    getRemoteRecords: (props: P) => R[],
  ) => (
    Component: WrappedComponentType<P>,
  ): EnhancedComponentType<P> => {
    const WithNotFoundHandler = (props: P): ReactElement => {
      const remoteRecords = getRemoteRecords(props);

      for (const remoteRecord of remoteRecords) {
        const { hasFailed, error } = remoteRecord;

        if (hasFailed && error && error.statusCode === StatusCodes.NOT_FOUND) {
          return <NotFoundPage />;
        }
      }

      return <Component {...props} />;
    };

    return WithNotFoundHandler;
  };
